import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-[500px]">
        <div className="w-32 h-32 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-5xl text-foreground-300"></i>
        </div>
        <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary-500 mb-4">404</h1>
        <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">页面不存在</h2>
        <p className="text-sm text-foreground-500 mb-8">
          抱歉，您访问的页面可能已经删除、移动或从未存在过。请尝试返回首页或使用搜索功能。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}